export default __webpack_public_path__ + "static/media/python-basic.0034ffcd.png";